import { useState } from "react";
import { api, brl, formatApiError } from "@/lib/api";
import { printPdfBlob } from "@/lib/print";
import { waUrl } from "@/lib/waTemplates";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileCheck2, Printer, Share2, Loader2 } from "lucide-react";

export function ReceiptButtons({ source, id, disabled }) {
  const [rec, setRec] = useState(null);
  const [blob, setBlob] = useState(null);
  const [busy, setBusy] = useState(false);
  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/receipts", { source, id });
      setRec(data);
      const r = await api.get(`/receipts/${data.id}/pdf`, { responseType: "blob" });
      setBlob(r.data);
      toast.success(`Recibo nº ${data.number} pronto`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const share = async () => {
    const file = new File([blob], `Recibo-${rec.number}.pdf`, { type: "application/pdf" });
    if (navigator.canShare?.({ files: [file] })) {
      try { await navigator.share({ files: [file], title: `Recibo nº ${rec.number}` }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    const text = `Olá, ${rec.payer}! Segue o recibo nº ${rec.number} de ${brl(rec.amount)}: ${rec.public_url}`;
    window.open(rec.phone ? waUrl(rec.phone, text) : `https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={`receipt-buttons-${source}`}>
      <Button data-testid="receipt-generate-btn" type="button" size="sm" variant="outline" disabled={disabled || busy} onClick={generate} className="bg-zinc-900 border-zinc-800">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><FileCheck2 className="h-4 w-4 mr-1" /> {rec ? `Recibo nº ${rec.number} · gerar de novo` : "Gerar recibo"}</>}
      </Button>
      {rec && blob && <>
        <Button data-testid="receipt-print-btn" type="button" size="sm" variant="outline" onClick={() => printPdfBlob(blob)} className="bg-zinc-900 border-zinc-800"><Printer className="h-4 w-4 mr-1" /> Imprimir</Button>
        <Button data-testid="receipt-share-btn" type="button" size="sm" onClick={share} className="bg-green-brand text-white font-bold"><Share2 className="h-4 w-4 mr-1" /> Compartilhar</Button>
      </>}
    </div>
  );
}
